import axios from '@/utils/api'
import { SET_FIELD_VALUE, SET_CONSTANTS, SET_CUSTA, SET_CUSTA_AGRARIA, SET_VTN, CLEAR_VTN, SET_PARCELAS, SET_PARCELAS_INDEX } from '../../mutation-types'
import _ from 'lodash'

const emptyDadosVtn = {
  id: null,
  areaRequerida: 0,
  fatorDistancia: null,
  fatorAcesso: null,
  tempoOcupacao: null,
  temDireitoRegularizacao: false,
  respeitaLegislacaoAmbiental: false,
  formaPagamento: null,
  quantidadeParcelas: null,
  valorEntrada: 0,
  custasVtn: [],
  custasAgrarias: 0,
  calculosVtn: {
    dadosParcelaGeoVtn: [],
    resumoParcelaExcedente: []
  },
  excedente: false
}

const state = {
  dadosVtn: _.cloneDeep(emptyDadosVtn),
  fatoresDistancia: [],
  fatoresAcesso: [],
  fatoresTempoOcupacao: [],
  tiposCustas: []
}

const getters = {
  fatoresDistancia: (state) => state.fatoresDistancia,
  fatoresAcesso: (state) => state.fatoresAcesso,
  dadosVtn: (state) => state.dadosVtn
}

const mutations = {
  [CLEAR_VTN] (state, dados) {
    state.dadosVtn = _.cloneDeep(emptyDadosVtn)
  },
  [SET_VTN] (state, dados) {
    state.dadosVtn = dados
  },
  [SET_PARCELAS_INDEX] (state, {index, dados}) {
    state.dadosVtn.calculosVtn.dadosParcelaGeoVtn[index] = dados
  },
  [SET_PARCELAS] (state, dados) {
    state.dadosVtn.calculosVtn.dadosParcelaGeoVtn = dados
  },
  [SET_FIELD_VALUE] (state, { field, value }) {
    state.dadosVtn[field] = value
  },
  [SET_CONSTANTS] (state, { fatoresAcesso, fatoresDistancia, fatoresTempoOcupacao, tiposCustas }) {
    state.fatoresAcesso = fatoresAcesso
    state.fatoresDistancia = fatoresDistancia
    state.fatoresTempoOcupacao = fatoresTempoOcupacao
    state.tiposCustas = tiposCustas
  },
  [SET_CUSTA] (state, value) {
    const index = state.dadosVtn.custasVtn.findIndex(item => item.tipoCusta.id === value.tipoCusta.id)
    if (index === -1) {
      state.dadosVtn.custasVtn.push(value)
    } else {
      state.dadosVtn.custasVtn.splice(index, 1)
    }
  },

  [SET_CUSTA_AGRARIA] (state, value) {
    const index = state.dadosVtn.custasVtn.findIndex(item => item.tipoCusta.id === value.tipoCusta.id)
    if (index === -1) {
      state.dadosVtn.custasVtn.push(value)
    } else {
      state.dadosVtn.custasVtn[index].quantidade = value.quantidade
      if (value.quantidade === 0) {
        state.dadosVtn.custasVtn.splice(index, 1)
      }
    }
  }
}

const actions = {
  async setDadosVtn ({ commit }) {
    const dados = axios()
    commit('SET_FIELD_VALUE', dados)
  },

  async setConstants ({ commit }) {
    const fatoresAcesso = await axios({
      method: 'get',
      url: 'financeiro/fatores/acesso'
    })

    const fatoresDistancia = await axios({
      method: 'get',
      url: 'financeiro/fatores/distancia'
    })

    const fatoresTempoOcupacao = await axios({
      method: 'get',
      url: 'financeiro/fatores/tempoOcupacao'
    })

    const tiposCustas = await axios({
      method: 'get',
      url: 'financeiro/vtn/tiposCustas'
    })

    commit('SET_CONSTANTS', { fatoresAcesso, fatoresDistancia, fatoresTempoOcupacao, tiposCustas })
  },

  async saveOrUpdate ({ commit, state }, numeroProcesso) {
    const result = await axios({
      method: 'post',
      url: 'financeiro/vtn',
      data: { ...state.dadosVtn, numeroProcesso }
    })

    commit('SET_VTN', result)

    return result
  },

  async finalizar ({ commit, state }) {
    const result = await axios({
      method: 'put',
      url: `financeiro/vtn/finalizar/${state.dadosVtn.id}`
    })

    return result
  },

  async getVtnProcesso ({ commit, state }, numeroProcesso) {
    const result = await axios({
      method: 'get',
      url: 'financeiro/vtn',
      params: {
        numeroProcesso
      }
    })

    if (result) {
      commit('SET_VTN', result)
    }

    return result
  },

  async getVtnProcessoId ({ commit, state }, idProcesso) {
    const result = await axios({
      method: 'get',
      url: `financeiro/vtn/findByIdProcesso/${idProcesso}`
    })

    if (result) {
      commit('SET_VTN', result)
    }

    return result
  },

  async exportarPdf ({ commit, state }) {
    await axios({
      method: 'get',
      url: `financeiro/vtn/exportar/${state.dadosVtn.id}`,
      responseType: 'blob' // Importante em caso de download de files
    })
  },

  async exportarPdfToDownload ({ commit, state }) {
    await axios({
      method: 'get',
      url: `financeiro/vtn/exportarPdfCustasProcessoais/${state.dadosVtn.id}`,
      responseType: 'blob' // Importante em caso de download de files,
    })
  },

  async exportarPdfToView ({ commit, state }, numeroProcesso) {
    const result = await axios({
      url: `financeiro/vtn/exportarToView`,
      method: 'get',
      params: {
        numeroProcesso
      },
      responseType: 'arraybuffer'
    })
    return result
  },

  async create ({ commit }, pvtn) {
    const result = await axios({
      url: 'analise/moduloVtn',
      method: 'POST',
      data: pvtn
    })

    return result
  },

  async updatePvtn ({ commit }, pvtn) {
    const result = await axios({
      url: 'analise/moduloVtn',
      method: 'PUT',
      data: pvtn
    })

    return result
  },

  async getPvtns ({ commit }, filtro) {
    const result = await axios({
      url: 'analise/moduloVtn',
      method: 'GET',
      params: filtro
    })

    return result
  },

  async getVigencias ({ commit }) {
    const result = await axios({
      url: 'analise/moduloVtn/get-vigencias',
      method: 'GET'
    })

    return result
  },

  async getVigenciasByYear ({ commit }, year) {
    const result = await axios({
      url: `analise/moduloVtn/vigencias/findByYear?year=${year}`,
      method: 'GET'
    })

    return result
  },

  async getPvtnsByVigencia ({ commit }, id) {
    const result = await axios({
      url: `analise/moduloVtn/vigencia/${id}/pvtns`,
      method: 'GET'
    })

    return result
  },
  async createVtn ({ commit }, pvtn) {
    const result = await axios({
      url: 'analise/moduloVtn/calcularVtn',
      method: 'POST',
      data: pvtn
    })

    return result
  },

  async createVtnPublico ({ commit }, pvtn) {
    const result = await axios({
      url: 'analise/moduloVtn/publico/calcularVtn',
      method: 'POST',
      data: pvtn
    })

    return result
  },

  async createUpf ({ commit }, upf) {
    const result = await axios({
      url: 'analise/moduloVtn/upf',
      method: 'POST',
      data: upf
    })
    return result
  },

  async getPvtnAtivo ({ commit }, idMunicipio) {
    const result = await axios({
      url: `analise/moduloVtn/find-ativo?idMunicipio=${idMunicipio}`,
      method: 'GET'
    })

    return result
  },

  async getPvtnAtivoPublico ({ commit }, idMunicipio) {
    const result = await axios({
      url: `analise/moduloVtn/publico/find-ativo?idMunicipio=${idMunicipio}`,
      method: 'GET'
    })

    return result
  },

  async updateUpf ({ commit }, upf) {
    const result = await axios({
      url: 'analise/moduloVtn/upf',
      method: 'PUT',
      data: upf
    })

    return result
  },

  async getAllUpfGroupByYear ({ commit }) {
    const result = await axios({
      url: `analise/moduloVtn/upf/group-by-year`,
      method: 'GET'
    })

    return result
  },

  async getVtnbyIdProcesso ({ commit }, idProcesso) {
    const result = await axios({
      url: `analise/moduloVtn/vtn/processo/${idProcesso}`,
      method: 'GET'
    })

    return result
  },

  async getAllVtn ({ commit }) {
    const result = await axios({
      url: `analise/moduloVtn/vtn`,
      method: 'GET'
    })

    return result
  },

  async findVtnByFilter ({ commit }, filtro) {
    const result = await axios({
      url: 'analise/moduloVtn/vtn/findByFilter',
      method: 'POST',
      data: filtro
    })

    return result
  },

  async findVtnByProcesso ({ commit }, id) {
    const result = await axios({
      url: `analise/moduloVtn/vtn/processo/${id}`,
      method: 'GET'
    })

    return result
  },

  async updateVtn ({ commit }, vtn) {
    const result = await axios({
      url: 'analise/moduloVtn/vtn',
      method: 'PUT',
      data: vtn
    })

    return result
  },

  async findVtnById ({ commit }, id) {
    const result = await axios({
      url: `analise/moduloVtn/vtn/${id}`,
      method: 'GET'
    })

    return result
  },

  async calcularVtn ({ commit }, pagamentoRequest) {
    const result = await axios({
      url: 'analise/moduloVtn/vtn/calcular',
      method: 'POST',
      data: pagamentoRequest
    })

    return result
  },

  async calcularVtnPublico ({ commit }, pagamentoRequest) {
    const result = await axios({
      url: 'analise/moduloVtn/publico/vtn/calcular',
      method: 'POST',
      data: pagamentoRequest
    })

    return result
  },

  async deleteVtnByIdVigencia ({ commit }, id) {
    const result = await axios({
      url: `analise/moduloVtn/pvtn/${id}`,
      method: 'DELETE'
    })

    return result
  },

  async findUpfByVigencia ({ commit }, dados) {
    const result = await axios({
      url: 'analise/moduloVtn/upf/by-year',
      method: 'GET',
      params: {
        ano: dados.ano,
        mes: dados.mes
      }
    })

    return result
  },

  async dadosCardsRelatorio ({ commit }) {
    const result = await axios({
      url: 'analise/moduloVtn/relatorio/dadosCards',
      method: 'GET'
    })

    return result
  },

  async dadosGraficoRelatorio ({ commit }, dados) {
    const result = await axios({
      method: 'POST',
      url: `analise/moduloVtn/relatorio/dadosGrafico?tipo=${dados.tipo}&parametro=${dados.parametro}&tipoData=${dados.tipoData}`,
      data: dados.filtro,
      error: true
    })

    return result
  },

  async dadosCardsGestao ({ commit }) {
    const result = await axios({
      url: 'analise/moduloVtn/gestao/dadosCardsGestao',
      method: 'GET'
    })

    return result
  },

  async calcularAdiantamento ({ commit }, adiantamentoRequest) {
    const result = await axios({
      url: `analise/moduloVtn/vtn/calcularAdiantamento/`,
      method: 'POST',
      data: adiantamentoRequest
    })

    return result
  },

  async updateParcelas ({ commit }, parcelas) {
    const result = await axios({
      url: 'analise/moduloVtn/parcelas',
      method: 'PUT',
      data: parcelas
    })

    return result
  },

  async reseteParcelas ({ commit }, id) {
    const result = await axios({
      url: `analise/moduloVtn/vtn/reseteParcelas/${id}`,
      method: 'DELETE'
    })

    return result
  },

  async salvarBoleto ({ commit }, boleto) {
    const result = await axios({
      url: 'documento/salvarBoleto',
      method: 'POST',
      data: boleto[0]
    })

    return result
  },

  async criarBoleto ({ commit }, boleto) {
    const result = await axios({
      url: 'analise/moduloVtn/boleto',
      method: 'POST',
      data: boleto
    })

    return result
  },

  async criarBoletos ({ commit }, boletos) {
    const result = await axios({
      url: 'analise/moduloVtn/boletos',
      method: 'POST',
      data: boletos
    })

    return result
  },

  async confirmarDadosVTNRR ({ commit }, id) {
    const result = await axios({
      url: `analise/moduloVtn/confirmarDadosVTNRR/${id}`,
      method: 'POST'
    })

    return result
  },

  async finalizarVTNRR ({ commit }, id) {
    const result = await axios({
      url: `analise/moduloVtn/finalizarVTNRR/${id}`,
      method: 'POST'
    })
    return result
  },

  async finalizarVTNMA ({ commit }, {idProcesso, acao, despacho}) {
    const result = await axios({
      url: `financeiro/vtn/finalizarVTNMA/${idProcesso}/${acao}`,
      method: 'PUT',
      data: despacho
    })
    return result
  },

  async salvarVTNMA ({ commit }, {id, dados}) {
    const result = await axios({
      url: `financeiro/vtn/salvarVTNMA/${id}`,
      method: 'POST',
      data: dados
    })
    return result
  },

  async deleteUpf ({ commit }, id) {
    const result = await axios({
      url: `analise/moduloVtn/upf/${id}`,
      method: 'DELETE'
    })

    return result
  },

  async finalizarVtnAP ({ commit }, dados) {
    const result = await axios({
      url: `analise/moduloVtn/finalizarVtnAP/${dados.processoId}?acao=${dados.acao}`,
      method: 'POST',
      data: dados.despacho
    })

    return result
  },
  async criarDespacho ({ commit }, dados) {
    const result = await axios({
      url: `analise/moduloVtn/criarDespacho/${dados.processoId}`,
      method: 'POST',
      data: dados.despacho
    })

    return result
  },
  async getParcelas ({ commit }, id) {
    const result = await axios({
      method: 'get',
      url: `financeiro/vtn/parcelas/processo/${id}`
    })
    return result
  },
  async getInfoCertidaoQuitacao ({ commit }, id) {
    const result = await axios({
      url: `financeiro/vtn/certidaoQuitacao/${id}`,
      method: 'GET'
    })

    return result
  },
  async enviaDadosCertidaoQuitacao ({ commit }, { id, dados }) {
    const result = await axios({
      url: `financeiro/vtn/certidaoQuitacao/${id}`,
      method: 'POST',
      data: dados
    })
    return result
  },
  async gerarCertidaoQuitacao ({ commit }, id) {
    const result = await axios({
      url: `financeiro/vtn/certidaoQuitacao/${id}/gerar`,
      method: 'GET'
    })

    return result
  },
  async getCertidaoQuitacaoGerada ({ commit }, id) {
    const result = await axios({
      url: `financeiro/vtn/certidaoQuitacao/${id}/pdf`,
      method: 'GET',
      responseType: 'arraybuffer'
    })

    return result
  },
  async getCertidaoQuitacaoView ({ commit }, id) {
    const result = await axios({
      url: `financeiro/vtn/certidaoQuitacao/${id}/view`,
      method: 'GET',
      responseType: 'arraybuffer'
    })

    return result
  },
  async getUpf () {
    const response = await axios({
      method: 'get',
      url: 'financeiro/upf'
    })
    return response
  },
  async getNewUpf () {
    const response = await axios({
      method: 'get',
      url: 'financeiro/upf/getUltimoUpf'
    })
    return response
  },

  async addUpf ({ commit }, newUpf) {
    await axios({
      method: 'post',
      url: 'financeiro/upf',
      data: newUpf
    })
  },
  async editUpf ({ commit }, ano) {
    const response = await axios({
      method: 'get',
      url: `financeiro/upf/${ano}`
    })
    return response
  },

  async updateUpfPa ({ commit }, updatedData) {
    await axios({
      method: 'put',
      url: `financeiro/upf/${updatedData.ano}`,
      data: updatedData
    })
  },

  async processoTemVtn ({commit}, numeroProcesso) {
    const response = await axios({
      method: 'get',
      url: `analise/moduloVtn/processoIsVtn?parametro=${numeroProcesso}`
    })
    return response
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/financeiro/vtn.js